export default function fetchData(url, method = 'GET', body = null, mode = 'cors') {
  const config = {
    method,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    mode,
  }

  if (!body) body = {}

  const sessionId = localStorage.getItem('sessionId')
  if (sessionId) {
    body.sessionID = sessionId
    // config.headers['Authorization'] = `${ sessionId }`;
  }

  // config.body = JSON.stringify(body); Perfect send
  if (method !== 'GET') {
    config.body = new URLSearchParams();
    for (const [key, value] of Object.entries(body)) {
      config.body.append(key, value);
    }
    // config.body = Object.entries(body)
    //   .map(e => e.join('='))
    //   .join('&')
  }

  return fetch(url, config)
}



// WEBPACK FOOTER //
// src/api/fetchData.js